import { render, staticRenderFns } from "./InceptionEnglishAssessmentIndex.vue?vue&type=template&id=9910dd08&scoped=true"
import script from "./InceptionEnglishAssessmentIndex.vue?vue&type=script&lang=ts"
export * from "./InceptionEnglishAssessmentIndex.vue?vue&type=script&lang=ts"
import style0 from "./InceptionEnglishAssessmentIndex.vue?vue&type=style&index=0&id=9910dd08&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9910dd08",
  null
  
)

export default component.exports